import { getClientAppContext, isAppContextOnClientSupported } from './app-context';
import { udApi } from './ud-api';
let promiseCache = {};
function createCacheKey(params) {
  const keys = Object.keys(params).sort(); // Sort the keys
  return keys.map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');
}
function generateCacheKeyArray(params) {
  return Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`);
}

/**
 * Fetches data from the `/api-2.0/contexts/me` endpoint and dedupes requests with the
 * same query params
 * @param params an object containing the query params specifying which data to fetch
 */
export async function fetchCommonAppData(params) {
  const cacheKey = createCacheKey(params);
  const cacheKeyArray = generateCacheKeyArray(params);
  let requestPromise = promiseCache[cacheKey];
  if (!requestPromise) {
    if (isAppContextOnClientSupported()) {
      requestPromise = getClientAppContext();
    } else {
      requestPromise = udApi.get('/contexts/me/', {
        params
      }).then(response => {
        return response.data ? response : Promise.reject(new Error('No data'));
      });
      promiseCache[cacheKey] = requestPromise;
    }
    cacheKeyArray.forEach(key => {
      promiseCache[key] = requestPromise;
    });

    // removed any failed promises from cache
    requestPromise.catch(() => {
      delete promiseCache[cacheKey];
      cacheKeyArray.forEach(key => {
        if (promiseCache[key] === requestPromise) {
          delete promiseCache[key];
        }
      });
    });
  }
  return requestPromise;
}
fetchCommonAppData.reset = () => {
  promiseCache = {};
};
//# sourceMappingURL=fetch-common-app-data.js.map